import { render, staticRenderFns } from "./BoardToolbar.vue?vue&type=template&id=dd48987e&scoped=true&"
import script from "./BoardToolbar.vue?vue&type=script&lang=js&"
export * from "./BoardToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BoardToolbar.vue?vue&type=style&index=0&id=dd48987e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd48987e",
  null
  
)

export default component.exports